import { FC } from 'react'
import Image from 'next/image'
import { publicAssetUrl } from '@chegg-wt/core/utils/url'
import { Button } from '@chegg-ui/button'
import { Typography } from '@chegg-ui/typography'
import { FeedbackTab } from '@chegg-wt/core-wa/constants/paraphraser'
import {
  setActiveFeedbackCardId,
  setActiveFeedbackTab,
} from '@chegg-wt/core-wa/state/actions'
import {
  GO_TEXT,
  KEEP_IMPROVING_TEXT,
  KEEP_UP_GOOD_WORK,
  NICELY_DONE_TEXT,
} from '@chegg-wt/core-wa/state/constants'
import { useDispatch } from 'react-redux'
import {
  BannerHeading,
  BannerWrapper,
  BannerText,
  ImageContainer,
  SuggestionsFor,
  KeepGrowingText,
  Container,
} from './styled'

const KEEP_IT_UP_IMG_WIDTH = 95
const KEEP_IT_UP_IMG_HEIGHT = 112

type NicelyDoneBannerProps = {
  textMessage: string
  activeTab: number
  remainingOtherTabFeedbacks: number
}

const NicelyDoneBanner: FC<NicelyDoneBannerProps> = ({
  textMessage,
  activeTab,
  remainingOtherTabFeedbacks,
}) => {
  const dispatch = useDispatch()
  const setActiveTab = (tabIndex: FeedbackTab) => {
    dispatch(setActiveFeedbackTab(tabIndex))
    // On changing active feedback tab reset the active feedback card to first card
    dispatch(setActiveFeedbackCardId(null))
  }
  const otherTabName = activeTab === FeedbackTab.GRAMMAR_TAB ? 'clarity' : 'grammar'
  const goToOtherTab = () => {
    const nextTabindexToGo =
      activeTab === FeedbackTab.GRAMMAR_TAB
        ? FeedbackTab.PARAPHRASE_TAB
        : FeedbackTab.GRAMMAR_TAB
    setActiveTab(nextTabindexToGo)
  }
  return (
    <Container>
      <BannerWrapper activeTab={activeTab}>
        <BannerText>
          <BannerHeading variant="h5" variantType="bold">
            {NICELY_DONE_TEXT}
          </BannerHeading>

          <Typography variant="body2" variantType="normal">
            {textMessage}
          </Typography>
        </BannerText>

        <ImageContainer>
          <Image
            src={publicAssetUrl('keepItUp.svg')}
            alt={KEEP_UP_GOOD_WORK}
            width={KEEP_IT_UP_IMG_WIDTH}
            height={KEEP_IT_UP_IMG_HEIGHT}
          />
        </ImageContainer>
      </BannerWrapper>

      <KeepGrowingText variant="body1" type="normal">
        {KEEP_IMPROVING_TEXT}
      </KeepGrowingText>

      <SuggestionsFor>
        <Typography variant="body2" variantType="bold">
          You have {remainingOtherTabFeedbacks} suggestions for {otherTabName}
        </Typography>
        <Button size="medium" width="60px" onClick={goToOtherTab}>
          {GO_TEXT}
        </Button>
      </SuggestionsFor>
    </Container>
  )
}

export default NicelyDoneBanner
